<div class="directions" *ngIf="directions">
    <div class="dir-inner scrollbars">
        <div class="dir-content">
            <div
                class="dir-map"
                [style.backgroundImage]="'url(' + directions.map_image + ')'"
                *ngIf="directions.map_image"
            ></div>
            <div class="dir-buttons">
                <button
                    type="button"
                    class="btn-gradient-directions dir-button-1"
                    (click)="downloadMap($event)"
                    [innerHTML]="directions.map_button_title"
                    *ngIf="directions.map_file"
                ></button>
                <button
                    type="button"
                    class="btn-gradient-directions dir-button-2"
                    (click)="openDirections($event)"
                    [innerHTML]="directions.directions_button_title"
                    *ngIf="directions.directions_url"
                ></button>
            </div>
        </div>
    </div>
</div>